// Vue
import Vue from 'vue'
import Vuex from 'vuex'
import pathify from '@/plugins/vuex-pathify'

// Modules
import * as modules from './modules'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules,
  plugins: [
    pathify.plugin,
  ],
  state: {
    todos: [
      {
        title: 'Finish Kespa Event Registration',
        priority: 'High',
        completed: false,
        tags: ['Joon B.', 'JJoNak'],
        inDate: '2021-03-25',
      },
      {
        title: 'Hiring New Sales Representative',
        priority: 'Medium',
        completed: false,
        tags: ['John Faker'],
        inDate: '2021-03-26',
      },
    ],
    allTags: [
      {
        name: 'John Faker',
        color: 'rgb(255, 203, 0)',
      },
      {
        name: 'JJoNak',
        color: 'rgb(102, 204, 255)',
      },
      {
        name: 'Seagull',
        color: 'rgb(162, 93, 220)',
      },
      {
        name: 'spirit_moon',
        color: 'rgb(24, 64, 128)',
      },
      {
        name: 'Joon B.',
        color: 'rgb(195, 67, 67)',
      },
    ],
    colors: [
      'blue',
      'indigo',
      'deep-purple',
      'cyan',
      'green',
      'orange',
      'grey darken-1',
    ],
    event_types: [
      'Meeting',
      'Competition',
      'Training',
      'Convention',
      'Networking',
      'Sponsorship',
      'Jobs Fair',
    ],
    events: [
      {
        name: 'Finland Games Job Fair',
        start: new Date(2021, 3, 21),
        end: new Date(2021, 3, 24),
        type: 'Jobs Fair',
        color: 'grey darken-1',
        location: 'Online',
        link: 'https://gamesjobfair.com/',
        timed: false,
        description: 'The event where we bring together some of the leading gaming studios in Finland and some of the brightest talent in the gaming industry. Due to the current pandemic situation, we are organizing a two-day online event on 21-22 April that will include various opportunities to engage and mingle – all from the comfort of your own workspace.',
      },
      {
        name: 'LudoNarraCon 2021',
        start: new Date(2021, 3, 23),
        end: new Date(2021, 3, 25),
        color: 'cyan',
        type: 'Convention',
        location: 'Online',
        link: 'https://www.ludonarracon.com/',
        timed: false,
        description: 'LudoNarraCon is a digital convention celebrating narrative video games, hosted on Steam. An initiative of indie label Fellow Traveller, it aims to create a platform to showcase and celebrate interesting and innovative narrative games, replicating as many of the aspects and benefits of the physical convention experience as possible within a digital format.',
      },
      {
        name: 'GamesBeat Summit 2021',
        start: new Date(2021, 3, 27),
        end: new Date(2021, 3, 28),
        color: 'green',
        type: 'Networking',
        location: 'Online',
        link: 'https://events.venturebeat.com/gamesbeat-summit-2021/',
        timed: false,
        description: 'GamesBeat Summit is the most intimate gaming event in the industry. Senior-level attendees return again and again knowing they?ll engage in genuine conversations, networking, and deal-making that come out of the Summit every year. Bringing together industry leaders for the 12th annual executive summit, the GamesBeat team aims to support content surrounding inclusion, mental health, next-gen updates, and major industry changes post-IDFA. Join us online for two days of content and networking on April 28-29, 2021!',
      },
      {
        name: 'Brazil Independent Games Festival',
        start: new Date(2021, 4, 4),
        end: new Date(2021, 4, 8),
        color: 'cyan',
        type: 'Convention',
        location: 'Online',
        link: 'https://www.bigfestival.com.br/homeen.html',
        timed: false,
        description: 'BIG Festival, the biggest indie games festival and the most important B2B market in Latin America, is back next May 5 to 9, 2021/ It will be a 100% digital event, São Paulo, Brazil. BIG reaches an audience of game lovers and professionals in Latam that you can only find here.',
      },
      {
        name: 'DevGAMM Spring 2021',
        start: new Date(2021, 3, 11),
        end: new Date(2021, 3, 13),
        color: 'indigo',
        type: 'Competition',
        location: 'Online',
        link: 'https://devgamm.com/spring2021',
        timed: false,
        description: 'DevGAMM Spring 2021 will be held online on May 12-14. The program includes professional speakers, reviews on game design, art, and marketing, as well as round tables and workshops.',
      },
      {
        name: 'Training Session',
        start: new Date(2021, 3, 27, 11),
        end: new Date(2021, 3, 27, 19),
        color: 'deep-purple',
        type: 'Training',
        location: 'Online',
        link: 'https://zoom.us',
        timed: true,
        description: 'Special Coaching Session',
      },
      {
        name: 'Training Session - Defensive Strategy',
        start: new Date(2021, 3, 19, 16),
        end: new Date(2021, 3, 19, 19),
        color: 'deep-purple',
        type: 'Training',
        location: 'Online',
        link: 'https://zoom.us',
        timed: true,
        description: 'Special Coaching Session',
      },
      {
        name: 'Training Session - Offensive Strategy',
        start: new Date(2021, 3, 20, 12),
        end: new Date(2021, 3, 20, 16),
        color: 'deep-purple',
        type: 'Training',
        location: 'Online',
        link: 'https://zoom.us',
        timed: true,
        description: 'Special Coaching Session',
      },
      {
        name: 'Training Session - Support',
        start: new Date(2021, 3, 21, 10),
        end: new Date(2021, 3, 21, 16),
        color: 'deep-purple',
        type: 'Training',
        location: 'Online',
        link: 'https://zoom.us',
        timed: true,
        description: 'Special Coaching Session',
      },
      {
        name: 'Match against Team Wolf',
        start: new Date(2021, 3, 18, 15),
        end: new Date(2021, 3, 18, 17),
        color: 'indigo',
        type: 'Competition',
        location: 'Online',
        link: 'www.twitch.com',
        timed: true,
        description: 'Match against Team Wolf',
      },
    ],
  },
  getters: {
    getTodos: (state) => {
      return state.todos
    },
    getAllTags: (state) => {
      return state.allTags
    },
    getAllNames: (state) => {
      var allNames = state.allTags.map(
        tag => {
          return tag.name
        },
      )
      return allNames
    },
    getEvents: (state) => {
      return state.events
    },
    getEventsColors: (state) => {
      return state.colors
    },
    getEventTypes: (state) => {
      return state.event_types
    },
    getPriorities: (state) => {
      return ['High', 'Medium', 'Low', 'None']
    },
    filterTags: state => {
      return (id) => state.allTags.filter(tag => {
        if (tag) { return tag.name.toLowerCase().includes(id.toLowerCase()) }
      })
    },
    colorPalete: state => state.colorPalete,
  },

  mutations: {
    // Set Initial Data
    CREATE_NEW_EVENT (state, payload) {
      state.events.push(payload)
    },
    SAVE_USER_DATA (state, payload) {
      state.userData = payload
    },
    ADD_NEW_TAG (state, payload) {
      state.allTags.push({ name: payload, color: state.defaultTagColor })
    },
    CREATE_NEW_TODO (state, payload) {
      state.todos.unshift(payload)
      var priority = payload.priority

      if (priority === 'High') {
        var pColor = '#f5365c'
      } else if (priority === 'Medium') {
        pColor = '#ffbb33'
      } else if (priority === 'Low') {
        pColor = '#5e72e4'
      } else {
        pColor = '#11cdef'
      }
      var assignment = ''
      assignment += payload.tags.join(' + ')
      var newEvent = {
        name: payload.title,
        color: pColor,
        start: payload.inDate,
        description: 'Assigned to: ' + assignment,
        type: 'Todo',
      }
      state.events.push(newEvent)
    },
    MARK_AS_COMPLETE (state, payload) {
      var index = state.todos.indexOf(payload)
      if (state.todos[index].completed) {
        state.todos[index].completed = false
      } else {
        state.todos[index].completed = true
      }
    },
    DELETE_TODO (state, payload) {
      state.todos.splice(state.todos.indexOf(payload), 1)
    },
    UPDATE_TOD_TAGS (state, payload) {
      state.todos.filter((e) => {
        if (e.id === payload.id) {
          e.tags = payload.tags
        }
      })
    },
    UPDATE_TODO (state, payload) {
      state.todos.forEach(element => {
        if (element.id === payload.id) {
          console.log('UPDATE ', element)
        }
      })
    },
    CHANGE_TAG_COLOR: (state, payload) => {
      state.allTags[payload.key].color = payload.color
    },
  },
  actions: {
    async createNewEvent ({
      commit,
    }, payload) {
      commit('CREATE_NEW_EVENT', payload)
    },
    async saveUserData ({
      commit,
    }, payload) {
      commit('SAVE_USER_DATA', payload)
    },
    async createNewTodo ({
      commit,
    }, payload) {
      commit('CREATE_NEW_TODO', payload)
    },
    async addNewTag ({
      commit,
    }, payload) {
      commit('ADD_NEW_TAG', payload)
    },
    async markAsComplete ({
      commit,
    }, payload) {
      commit('MARK_AS_COMPLETE', payload)
    },
    async updateTodo ({
      commit,
    }, payload) {
      commit('UPDATE_TODO', payload)
    },
    async deleteTodo ({
      commit,
    }, payload) {
      commit('DELETE_TODO', payload)
    },
    async changeTagColor ({
      commit,
    }, tag) {
      commit('CHANGE_TAG_COLOR', tag)
    },
    async updateTodoTags ({
      commit,
    }, payload) {
      commit('UPDATE_TOD_TAGS', payload)
    },
  },
})

store.subscribe(mutation => {
  if (!mutation.type.startsWith('user/')) return

  store.dispatch('user/update', mutation)
})

store.dispatch('app/init')

export default store

export const ROOT_DISPATCH = Object.freeze({ root: true })
